<template>
  <q-item :class="{ 'hovered': hovered }">
    <q-item-side>
      <q-item-tile avatar>
        <placeholder-avatar :initials="initials" height="38px" width="38px"/>
      </q-item-tile>
    </q-item-side>

    <q-item-main>
      <div class="row items-center gutter-x-md q-pl-md">
        <div class="col-md-4 col-6 blurred">
          <div class="q-item-label" :class="{ 'text-italic': !invite.name }">
            {{ name }}
          </div>

          <div class="q-item-sublabel">
            {{ $t('invited') }}
          </div>
        </div>

        <div class="col-4 gt-sm blurred">
          <span class="text-faded">{{ invite.email }}</span>
        </div>

        <div v-if="user.isAdminOf(team)" class="col-md-4 col-6 text-right team-list-entry__controls">
          <q-btn icon="more_vert" flat dense>
            <q-popover @show="hovered = true" @hide="hovered = false">
              <q-list separator link>
                <!-- Copy invite link -->
                <q-item
                  v-close-overlay
                  v-clipboard:copy="tokenLink"
                  v-clipboard:success="handleClipboardSuccess"
                  v-clipboard:error="handleClipboardError"
                >
                  <q-item-side icon="content_copy"/>
                  <q-item-main :label="$t('copy_link')"/>
                </q-item>

                <!-- Delete invite -->
                <q-item v-close-overlay @click.native="handleDeleteInvite">
                  <q-item-side icon="delete"/>
                  <q-item-main :label="$t('remove')"/>
                </q-item>
              </q-list>
            </q-popover>
          </q-btn>
        </div>
      </div>
    </q-item-main>
  </q-item>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import PlaceholderAvatar from 'components/Common/PlaceholderAvatar.vue'
  import { createErrorFromResponse } from 'src/utils/error'
  import i18n from 'src/i18n/i18n'

  export default {
    props: {
      invite: {
        required: true,
        type: Object
      }
    },

    data () {
      return {
        hovered: false
      }
    },

    computed: {
      ...mapGetters(['user', 'team']),

      initials () {
        return this.name.split(' ').slice(0, 2).map(str => str.charAt(0)).join('').toUpperCase()
      },

      name () {
        return this.invite.name ? this.invite.name : this.$t('unknown')
      },

      tokenLink () {
        return window.location.origin + this.$router.resolve({
          name: 'accept-invite',
          params: { token: this.invite.token }
        }).href
      }
    },

    methods: {
      ...mapActions(['removeTeamInvite']),

      handleDeleteInvite () {
        this.removeTeamInvite(this.invite.id)
          .then(() => {
            this.$q.notify({ message: i18n.t('invite_removed'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      },

      handleClipboardSuccess () {
        this.$q.notify({ message: this.$t('link_copied'), type: 'positive' })
      },

      handleClipboardError () {
        this.$q.notify({ message: this.$t('copy_failed'), type: 'negative' })
      }
    },

    components: {
      PlaceholderAvatar
    }
  }
</script>
